<template>
  <v-card flat color="transparent" class="pa-1 pa-sm-4">
    <!-- ── Barra superior ── -->
    <v-row align="center" class="mb-2" no-gutters style="gap: 8px">
      <!-- Sucursal -->


      <!-- Buscador -->
      <v-col cols="12" md="3">
        <v-text-field
          v-model="searchQuery"
          placeholder="Buscar producto..."
          outlined
          rounded
          filled
          dense
          hide-details
          clearable
          prepend-inner-icon="mdi-magnify"
          :disabled="!selectedSucursal"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        ></v-text-field>
      </v-col>
            <v-col v-if="sucursales.length > 1" cols="12" md="3">
        <v-select
          v-model="selectedSucursal"
          :items="sucursales"
          item-text="nombre"
          return-object
          label="Sucursal"
          outlined
          rounded
          filled
          dense
          hide-details
          clearable
          prepend-inner-icon="mdi-store"
          @change="onSucursalChange"
        ></v-select>
      </v-col>

      <!-- Botón filtrar -->
      <v-col cols="auto">
        <v-chip
          outlined
          :color="tieneFilrosActivos ? 'primary' : ''"
          @click="dialogFiltros = true"
          style="cursor: pointer"
        >
          <v-icon left small>mdi-filter-variant</v-icon>
          Filtrar y ordenar
          <v-avatar
            v-if="cantidadFiltros > 0"
            right
            color="primary"
            size="18"
            class="ml-1"
          >
            <span style="font-size: 10px; color: white">{{
              cantidadFiltros
            }}</span>
          </v-avatar>
        </v-chip>
      </v-col>

      <!-- Chips de filtros activos -->
      <v-col cols="auto" class="d-flex align-center flex-wrap" style="gap: 4px">
        <v-chip
          v-if="selectedCategoria"
          small
          close
          color="primary"
          outlined
          @click:close="clearCategoria"
        >
          <v-icon left x-small>mdi-tag-outline</v-icon>
          {{ selectedCategoria.name }}
        </v-chip>
        <v-chip
          v-if="selectedProveedor"
          small
          close
          color="primary"
          outlined
          @click:close="clearProveedor"
        >
          <v-icon left x-small>mdi-truck-outline</v-icon>
          {{ selectedProveedor.nombre }}
        </v-chip>
      </v-col>

    </v-row>

    <v-divider class="mb-3"></v-divider>

    <!-- ── Sin sucursal ── -->
    <v-alert
      v-if="!selectedSucursal"
      type="info"
      text
      dense
      rounded="lg"
      icon="mdi-store"
      class="mt-4"
    >
      Seleccioná una sucursal para ver los precios.
    </v-alert>

    <!-- ── Toolbar de selección ── -->
    <v-slide-y-transition>
      <div
        v-if="selectedSucursal && !loading_productos_admin"
        class="d-flex align-center px-2 mb-4"
        style="gap: 8px; min-height: 36px"
      >
        <v-checkbox
          :input-value="allSelected"
          :indeterminate="someSelected"
          dense
          hide-details
          class="mt-0 pt-0 flex-shrink-0"
          @change="toggleSelectAll"
        />
        <v-slide-x-transition>
          <span v-if="selectedItems.length > 0" class="caption grey--text">
            {{ selectedItems.length }} seleccionado{{ selectedItems.length !== 1 ? 's' : '' }}
          </span>
          <span v-else class="grey--text">Seleccionar productos</span>
        </v-slide-x-transition>

        <v-spacer />

        <v-btn
          small
          outlined
          color="primary"
          :disabled="selectedItems.length === 0"
          @click="$emit('editor-masivo', selectedItems)"
        >
          <v-icon small left>mdi-table-edit</v-icon>
          Editor masivo
        </v-btn>
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small outlined color="teal" v-bind="attrs" v-on="on">
              <v-icon small left>mdi-microsoft-excel</v-icon>
              Modificar desde Excel
              <v-icon small right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              :disabled="selectedItems.length === 0"
              @click="$router.push({ name: 'empresa.productos.listaPrecios', query: { ids: selectedItems.join(',') } })"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Actualizar precios</v-list-item-title>
                <v-list-item-subtitle>Con los productos seleccionados</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="$router.push({ name: 'empresa.productos.listaPrecios', query: selectedProveedor ? { proveedor_id: selectedProveedor.id } : {} })"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Lista de precios proveedor</v-list-item-title>
                <v-list-item-subtitle>Plantilla por proveedor</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-divider vertical class="mx-1" />

        <v-menu v-model="menuPDF" :close-on-content-click="false" offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small outlined color="red darken-1" :disabled="!selectedSucursal" v-bind="attrs" v-on="on">
              <v-icon small left>mdi-file-pdf-box</v-icon>
              PDF
              <v-icon small right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-card min-width="300" class="pa-4">
            <div class="text-caption grey--text text-uppercase font-weight-bold mb-2">Agrupar por</div>
            <v-btn-toggle v-model="agruparPor" mandatory color="primary" rounded dense class="mb-4">
              <v-btn value="categoria" small>Categoría</v-btn>
              <v-btn value="proveedor" small>Proveedor</v-btn>
            </v-btn-toggle>
            <div class="text-caption grey--text text-uppercase font-weight-bold mb-2">Tipo</div>
            <v-btn-toggle v-model="tipo" mandatory color="primary" rounded dense class="mb-1">
              <v-btn value="simple" small>Simple</v-btn>
              <v-btn value="detallado" small>Detallado</v-btn>
              <v-btn value="comercial" small>Comercial</v-btn>
            </v-btn-toggle>
            <div class="caption grey--text mb-4">
              <span v-if="tipo === 'simple'">Nombre y precio de venta</span>
              <span v-else-if="tipo === 'detallado'">Con costo y ganancia</span>
              <span v-else>Para entregar al cliente: membrete, código y precio</span>
            </div>

            <!-- Encabezado de la lista comercial -->
            <template v-if="tipo === 'comercial'">
              <v-text-field
                v-model="tituloComercial"
                label="Título"
                dense
                outlined
                hide-details
                class="mb-3"
              ></v-text-field>
              <v-text-field
                v-model="periodoComercial"
                label="Período"
                dense
                outlined
                hide-details
                class="mb-1"
              ></v-text-field>
              <v-switch
                v-model="soloUnidad"
                label="Solo precio unitario"
                dense
                hide-details
                class="mt-2 mb-1"
              ></v-switch>
              <div class="caption grey--text mb-4">
                Sin esto también salen el paquete y el bulto.
              </div>
            </template>

            <v-btn color="primary" block depressed small :loading="loadingDescarga" @click="descargarPDF">
              <v-icon left small>mdi-download</v-icon>
              Descargar
            </v-btn>
          </v-card>
        </v-menu>
      </div>
    </v-slide-y-transition>

    <!-- ── Header columnas ── -->
    <v-row
      v-if="selectedSucursal && !loading_productos_admin"
      no-gutters
      class="px-2 mb-1 hidden-sm-and-down"
      align="center"
    >
      <v-col cols="3"
        ><span class="caption grey--text text-uppercase font-weight-bold"
          >Producto</span
        ></v-col
      >
      <v-col cols="4"
        ><span class="caption grey--text text-uppercase font-weight-bold"
          >Precios</span
        ></v-col
      >
      <v-col cols="2"
        ><span class="caption grey--text text-uppercase font-weight-bold text-center d-block"
          >Calidad</span
        ></v-col
      >
      <v-col cols="3" class="text-right"
        ><span class="caption grey--text text-uppercase font-weight-bold"
          >Estado</span
        ></v-col
      >
    </v-row>

    <!-- ── Skeleton ── -->
    <template v-if="loading_productos_admin">
      <v-row
        v-for="n in 8"
        :key="'sk-' + n"
        class="align-center py-3 px-2"
        no-gutters
      >
        <v-col cols="3" class="d-flex align-center" style="gap: 12px">
          <v-skeleton-loader
            type="image"
            width="48"
            height="48"
            class="rounded flex-shrink-0"
          />
          <div style="flex: 1">
            <v-skeleton-loader type="text" width="140px" class="mb-2" />
            <v-skeleton-loader type="text" width="90px" />
          </div>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader type="text" width="80px" class="mb-2" />
          <v-skeleton-loader type="text" width="120px" />
        </v-col>
        <v-col cols="2"><v-skeleton-loader type="chip" width="60px" /></v-col>
        <v-col cols="2"><v-skeleton-loader type="text" width="80px" /></v-col>
        <v-col cols="2"></v-col>
      </v-row>
    </template>

    <!-- ── Empty state ── -->
    <div
      v-else-if="selectedSucursal && productos_admin.length === 0"
      class="empty-state"
    >
      <v-icon large color="grey darken-1">mdi-magnify</v-icon>
      <p class="body-2 grey--text mt-3">
        No se encontraron productos con los filtros aplicados.
      </p>
    </div>

    <!-- ── Lista ── -->
    <template v-else-if="selectedSucursal">
      <precio-list-item
        v-for="item in productos_admin"
        :key="item.id"
        :item="item"
        :uuid-sucursal="selectedSucursal ? selectedSucursal.uuid : null"
        :selected="selectedItems.includes(item.id)"
        @toggle-activo="onToggleActivo"
        @editar-precio="onEditarPrecio"
        @toggle-select="onToggleSelect"
      />
    </template>

    <!-- ── Dialog filtros ── -->
    <v-dialog v-model="dialogFiltros" max-width="640" scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title
          class="d-flex align-center justify-space-between py-3 px-5"
        >
          <span class="text-subtitle-1 font-weight-bold"
            >Filtrar y ordenar</span
          >
          <v-btn icon small @click="dialogFiltros = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <v-row no-gutters>

            <!-- ── Categoría ── -->
            <v-col cols="12" sm="6" class="col-categoria">
              <div class="px-4 pt-4 pb-2 text-caption grey--text text-uppercase font-weight-bold">
                Categoría
                <v-chip v-if="selectedCategoriaTemp" x-small color="primary" class="ml-2">
                  {{ selectedCategoriaTemp.name }}
                  <v-icon x-small right @click.stop="selectedCategoriaTemp = null">mdi-close</v-icon>
                </v-chip>
              </div>
              <div class="px-4 pb-4">
                <v-btn outlined block class="text-none justify-space-between" @click="pickerCategoria = true">
                  {{ selectedCategoriaTemp ? selectedCategoriaTemp.name : "Elegir categoría" }}
                  <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
              <categoria-picker
                v-model="pickerCategoria"
                :solo-hojas="false"
                :seleccionada="selectedCategoriaTemp"
                @select="(cat) => (selectedCategoriaTemp = cat)"
              />
            </v-col>

            <!-- ── Proveedor ── -->
            <v-col cols="12" sm="6">
              <div class="px-4 pt-4 pb-2 text-caption grey--text text-uppercase font-weight-bold">
                Proveedor
                <v-chip v-if="selectedProveedorTemp" x-small color="primary" class="ml-2">
                  {{ selectedProveedorTemp.nombre }}
                  <v-icon x-small right @click.stop="selectedProveedorTemp = null">mdi-close</v-icon>
                </v-chip>
              </div>
              <proveedor-list-select
                :key="dialogFiltros"
                @set_proveedor="selectProveedorDialog"
              />
            </v-col>

          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-5 py-3 d-flex justify-space-between">
          <v-btn text small @click="limpiarFiltrosDialog"
            >Limpiar filtros</v-btn
          >
          <div style="gap: 8px" class="d-flex">
            <v-btn text small @click="dialogFiltros = false">Cancelar</v-btn>
            <v-btn depressed small color="primary" @click="aplicarFiltros"
              >Aplicar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PrecioListItem from "@/views/empresa/productos/components/PrecioListItem.vue";
import CategoriaPicker from "@/components/categorias/CategoriaPicker.vue";
import ProveedorListSelect from "@/components/proveedor/ProveedorListSelect.vue";

const MESES = [
  "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
  "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE",
];

// Período que encabeza la lista comercial, ej "AGOSTO 2026". Es editable:
// una lista se arma a veces a fin de mes para el mes que viene.
function periodoActual() {
  const hoy = new Date();
  return `${MESES[hoy.getMonth()]} ${hoy.getFullYear()}`;
}

export default {
  name: "GestionListadoPrecios",
  components: { PrecioListItem, CategoriaPicker, ProveedorListSelect },
  data() {
    return {
      selectedSucursal: null,
      selectedCategoria: null,
      selectedProveedor: null,
      // estado temporal del dialog (se confirma al presionar Aplicar)
      selectedCategoriaTemp: null,
      pickerCategoria: false,
      selectedProveedorTemp: null,
      agruparPor: "categoria",
      tipo: "simple",
      tituloComercial: "LISTA DE PRECIOS DISTRIBUIDOR",
      periodoComercial: periodoActual(),
      soloUnidad: true,
      searchQuery: "",
      dialogFiltros: false,
      menuPDF: false,
      loadingDescarga: false,
      debounceSearch: null,
      selectedItems: [],
    };
  },
  computed: {
    ...mapState("sucursales", ["sucursales", "sucursal"]),
    ...mapState("productos", ["productos_admin", "loading_productos_admin"]),
    allSelected() {
      return this.productos_admin.length > 0 && this.selectedItems.length === this.productos_admin.length;
    },
    someSelected() {
      return this.selectedItems.length > 0 && !this.allSelected;
    },
    tieneFilrosActivos() {
      return !!(this.selectedCategoria || this.selectedProveedor);
    },
    cantidadFiltros() {
      return [this.selectedCategoria, this.selectedProveedor].filter(Boolean)
        .length;
    },
  },
  watch: {
    dialogFiltros(val) {
      if (val) {
        this.selectedCategoriaTemp = this.selectedCategoria;
        this.selectedProveedorTemp = this.selectedProveedor;
      }
    },
  },
  methods: {
    ...mapActions("sucursales", ["fetch_sucursales"]),
    ...mapActions("productos", ["get_productos_psp_for_params"]),

    onSucursalChange() {
      this.selectedCategoria = null;
      this.selectedProveedor = null;
      this.searchQuery = "";
      this.selectedItems = [];
      this.fetchProductos();
    },

    onSearchInput() {
      clearTimeout(this.debounceSearch);
      this.debounceSearch = setTimeout(() => this.fetchProductos(), 400);
    },

    onSearchClear() {
      this.searchQuery = "";
      this.fetchProductos();
    },

    clearCategoria() {
      this.selectedCategoria = null;
      this.fetchProductos();
    },

    clearProveedor() {
      this.selectedProveedor = null;
      this.fetchProductos();
    },


    selectProveedorDialog(prov) {
      this.selectedProveedorTemp = prov;
    },

    limpiarFiltrosDialog() {
      this.selectedCategoriaTemp = null;
      this.selectedProveedorTemp = null;
    },

    aplicarFiltros() {
      this.selectedCategoria = this.selectedCategoriaTemp;
      this.selectedProveedor = this.selectedProveedorTemp;
      this.dialogFiltros = false;
      this.fetchProductos();
    },

    fetchProductos() {
      if (!this.selectedSucursal) return;
      const params = [
        { key: "global", value: false },
        { key: "uuid_s", value: this.selectedSucursal.uuid },
      ];
      if (this.searchQuery?.trim()) {
        const search = this.searchQuery.trim();
        const isBarcode = /^\d+$/.test(search) && search.length > 6;
        params.push({ key: isBarcode ? "barcode" : "q", value: search });
      }
      if (this.selectedCategoria)
        params.push({ key: "categoria", value: this.selectedCategoria.name });
      if (this.selectedProveedor)
        params.push({ key: "proveedor", value: this.selectedProveedor.nombre });
      this.get_productos_psp_for_params(params);
    },


    onToggleSelect(item) {
      const idx = this.selectedItems.indexOf(item.id);
      if (idx === -1) {
        this.selectedItems.push(item.id);
      } else {
        this.selectedItems.splice(idx, 1);
      }
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.productos_admin.map((p) => p.id);
      }
    },
    async onToggleActivo({ item, activo }) {
      try {
        await this.axios.patch(`/productos/psp/${item.id}`, { activo });
        item.activo = activo;
      } catch {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "Error al actualizar el estado",
          icon: "mdi-alert",
          timeout: 3000,
        });
      }
    },

    onEditarPrecio(item) {
      this.$router.push({
        name: "empresa.producto.detalle",
        params: { id_producto: item.ps_id },
      });
    },

    async descargarPDF() {
      this.loadingDescarga = true;
      try {
        const params = {
          sucursal_id: this.selectedSucursal.id,
          agrupar_por: this.agruparPor,
          tipo: this.tipo,
        };
        if (this.selectedCategoria)
          params.categoria_id = this.selectedCategoria.id;
        if (this.selectedProveedor)
          params.proveedor_id = this.selectedProveedor.id;

        if (this.tipo === "comercial") {
          params.titulo = this.tituloComercial;
          params.subtitulo = this.periodoComercial;
          params.solo_base = this.soloUnidad;
        }

        const response = await this.axios.get("/reportes/listado-precios", {
          params,
          responseType: "blob",
        });

        const url = URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        const match =
          response.headers["content-disposition"]?.match(/filename="(.+)"/);
        link.download = match ? match[1] : "listado_precios.pdf";
        link.click();
        URL.revokeObjectURL(url);
        this.menuPDF = false;
      } catch {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "Error al generar el PDF",
          icon: "mdi-alert",
          timeout: 3000,
        });
      } finally {
        this.loadingDescarga = false;
      }
    },
  },
  async created() {
    await this.fetch_sucursales();
    if (this.sucursal) {
      this.selectedSucursal = this.sucursal;
    } else if (this.sucursales.length === 1) {
      this.selectedSucursal = this.sucursales[0];
    }
    if (this.selectedSucursal) {
      this.fetchProductos();
    }
  },
};
</script>

<style scoped>
.col-categoria {
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}
@media (max-width: 599px) {
  .col-categoria {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
}
.empty-state {
  text-align: center;
  padding: 48px 24px;
}
.filtro-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}
.filtro-grid .v-chip {
  justify-content: center;
}
</style>
